<template>
	<!-- 我的评价 -->
	<div class="evaluate">
		<div class="tabbar">
			<el-button type="primary" size="medium" v-for="(item, index) in category" :key="index" :plain="index!=categoryIndex" @click="changeTable(index)">{{item}}</el-button>
		</div>
		<div class="table" v-show="categoryIndex == 0">
			<el-table :data="tableData" stripe>
				<el-table-column type="index" align="center" label="序号" width="100"></el-table-column>
				<el-table-column align="left" label="订单信息" width="300">
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;">
							<!-- <img :src="$imgUrl + scope.row.pictureUrl" alt="" style="width: 30px;height: 30px;margin-right: 10px;"> -->
							<span>{{scope.row.orderNo}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column align="left" label="评价用户" width="200">
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;">
							<img :src="$imgUrl + scope.row.heading" alt="" style="width: 30px;height: 30px;margin-right: 10px;" alt="">
							<span>{{scope.row.customerName}}</span>
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column label="订单类型" align="center" prop="orderType" width="200"></el-table-column> -->
				<el-table-column align="center" label="评价状态" >
					<template slot-scope="scope">
						<span>{{scope.row.reply == 2 ? '已评价'  : '未评价'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="primary" size="medium" plain @click="jump(1,scope.row.id)">回复</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="text-align: right;margin-top: 20px;"
			  background
			  layout="prev, pager, next,total"
			  :current-change="pageNumChange"
			  :total="page.total">
			</el-pagination>
		</div>
		<div class="table" v-show="categoryIndex == 1">
			<el-table :data="tableData" stripe>
				<el-table-column type="index" align="center" label="序号" width="100"></el-table-column>
				<el-table-column align="left" label="订单信息" width="300">
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;">
							<span>{{scope.row.orderNo}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column align="left" label="评价用户" width="200">
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;">
							<img :src="$imgUrl + scope.row.heading" alt="" style="width: 30px;height: 30px;margin-right: 10px;" alt="">
							<span>{{scope.row.customerName}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="评价状态" width="100">
					<template slot-scope="scope">
						<span>{{scope.row.reply == 2 ? '已评价'  : '未评价'}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" label="评分">
					<template slot-scope="scope">
						<span>{{scope.row.fractionUser || 0}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="primary" size="medium" plain @click="jump(2,scope.row.id)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="text-align: right;margin-top: 20px;"
			  background
			  layout="prev, pager, next,total"
			  :current-change="pageNumChange"
			  :total="page.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import { elecPingListApi } from '../../http/electrician/api.js';
export default {
	name: 'evaluate',
	data() {
		return {
			category: ['未评价', '已评价'],
			categoryIndex: 0,
			tableData: [],
			page: {
				pageSize: 10,
				pageNum: 1,
				total: 0
			}
		};
	},
	created() {
		this.getList(1)
	},
	methods: {
		getList(reply){
			elecPingListApi({
				reply,
				pageSize: this.page.pageSize,
				pageNum: this.page.pageNum,
				status:6
			}).then(res => {
				this.tableData = res.rows
				this.page.total = res.total
			})
		},
		jump(type,id) {
			// this.$router.push({
			// 	path: '/electricianUser/eleEvaluateDetail',
			// 	query: {
			// 		type,
			// 		orderId: id
			// 	}
			// });
			this.$router.push({
				path: '/electricianUser/eleDetail',
				query: {
					id: id
				}
			});
		},
		// 更换表格
		changeTable(index) {
			if (index == 0) {
				this.getList(1)
			} else {
				this.getList(2)
			}
			this.categoryIndex = index
		},
		pageNumChange(val){
			this.page.pageNum = val
		}
	}
};
</script>

<style lang="less" scoped="scoped">
.evaluate {
	width: 100%;
	background: @vue-bg-color;
	.tabbar{
		width: 100%;
		height: 60px;
		display: flex;
		align-items: flex-end;
		padding: 0px @vue-spacing-row-base;
		box-sizing: border-box;
	}
	.table{
		width: 100%;
		height: 810px;
	}
}
</style>
